module.exports = __webpack_public_path__ + "static/media/icon_198.f80a1db2.svg";